import { render, staticRenderFns } from "./db.html?vue&type=template&id=30a87c0f&scoped=true&"
import script from "./db.js?vue&type=script&lang=js&"
export * from "./db.js?vue&type=script&lang=js&"
import style0 from "./db.scss?vue&type=style&index=0&id=30a87c0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a87c0f",
  null
  
)

export default component.exports